<div ngbDropdown class="w-full" (openChange)="onDropdownToggle($event)">
  <input [(ngModel)]="formattedDuration" class="form-control" required ngbDropdownToggle readonly (blur)="onTouched()" [disabled]="disabled">
  <div ngbDropdownMenu aria-labelledby="duration-picker">
    <app-duration-picker (valueChange)="onValueChange($event)" [totalSeconds]="totalSeconds"></app-duration-picker>
  </div>
</div>